module.exports = __webpack_public_path__ + "static/img/2_06.e181804.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/docs/03/2_06.jpg
// module id = X+pu
// module chunks = 1